import { put, select, take } from 'redux-saga/effects';
import notification from 'antd/lib/notification';
// internal
import history from '@app/components/router/history';
import * as ActionType from '@app/store/typings/actions/brand.d';
import * as brandService from '@app/services/brand';
import { handleError } from '@app/utils/service';
import { RootState } from '@app/store/typings/state/root';

export function* roleInBrandWithId({ payload }: ActionType.BrandRoleWithId) {
  try {
    const check: boolean = yield select((state: RootState) => state.brand.currentBrand._id);
    if (!check) {
      yield take('KEY_BRAND_SET_WITHID');
    }
    const brandId: string = yield select((state: RootState) => state.brand.currentBrand._id);
    const { data } = yield brandService.fetchRoleInBrandWithId(brandId, payload);
    if (data.success) {
      yield put<ActionType.BrandType>({
        type: 'KEY_BRAND_SET_CURRENTROLE',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* listRolesInBrand({ payload }: ActionType.FetchListRolesBrand) {
  try {
    const check: boolean = yield select((state: RootState) => state.brand.currentBrand._id);
    if (!check) {
      yield take('KEY_BRAND_SET_WITHID');
    }
    const brandId: string = yield select((state: RootState) => state.brand.currentBrand._id);
    const { data } = yield brandService.listRoleInBrand(brandId, payload.offset, payload.limit);
    if (data.success) {
      yield put<ActionType.BrandType>({
        type: 'KEY_BRAND_SET_LISTROLES',
        payload: {
          data: data.data,
          meta: data.meta,
        },
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* createRoleInBrand({ payload }: ActionType.CreateRoleBrand) {
  try {
    const brandId: string = yield select((state: RootState) => state.brand.currentBrand._id);
    const { data } = yield brandService.createRoleInBrand(
      brandId,
      payload.roleName,
      payload.permission,
    );
    if (data.success) {
      notification.success({ message: 'Success', description: 'Create role successfully' });
      const subpath = history.location.pathname.split('/');
      const pathname = subpath.slice(0, subpath.length - 1).join('/');
      history.push(pathname);
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* updateRoleInBrand({ payload }: ActionType.UpdateRoleBrand) {
  try {
    const state: {
      brandId: string;
      roleId: string;
    } = yield select((state: RootState) => ({
      brandId: state.brand.currentBrand._id,
      roleId: state.brand.listRole.currentRole?._id,
    }));
    const { data } = yield brandService.updateRoleInBrand(
      state.brandId,
      state.roleId,
      payload.roleName,
      payload.permission,
    );
    if (data.success) {
      notification.success({ message: 'Success', description: 'Update role successfully' });
      const subpath = history.location.pathname.split('/');
      const pathname = subpath.slice(0, subpath.length - 1).join('/');
      history.push(pathname);
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* deleteRolesInBrand({ payload }: ActionType.DeleteRolesBrand) {
  try {
    const brandId: string = yield select((state: RootState) => state.brand.currentBrand._id);
    const offset: number = yield select((state: RootState) => state.brand.listRole.meta.offset);
    const total: number = yield select((state: RootState) => state.brand.listRole.meta.total);
    const limit: number = yield select((state: RootState) => state.brand.listRole.meta.limit);
    const realOffset =
      offset === total - payload.roleId.length && offset !== 0 ? offset - limit : offset;
    let count = 0;
    for (let i = 0; i < payload.roleId.length; i++) {
      const { status } = yield brandService.deleteRolesInBrand(brandId, payload.roleId[i]);
      if (status === 204) {
        count += 1;
      }
    }
    if (count === payload.roleId.length) {
      notification.success({ message: 'Success', description: 'Delete role successfully' });
      yield put<ActionType.BrandType>({
        type: 'KEY_BRAND_FETCH_LISTROLES',
        payload: {
          offset: realOffset,
          limit: limit,
        },
      });
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}
